// extracted by mini-css-extract-plugin
export default {"defaultRoleText":"O_7sqUp3vtAUkXvixM_1","defaultRoleTextLabel":"wkiiA4mw8QzqWM5kD431"};